export default {
    'aboutSeller' : 'про продавця',
    'aboutProduct' : 'про товар',
    'aboutUs' : 'Про нас',
    'aboutAgrolink' : 'Про AGROLINK',
    'absent': 'вітсутня',
    'accountDeleted' : "Аккаунт заблокований. Зв'яжіться з адміністрацією для уточнення деталей.",
    'actionRequireLogin' : 'Для здійснення цієї дії авторизуйтесь будьласка',
    'activateError' : 'Помилка активації облікового запису. Зв\'яжіться з адміністрацією.',
    'activeIngredient' : 'Діюча речовина',
    'actualBudget' : 'Фактичний бюджет',
    'add' : 'Додати',
    'addCondition' : 'Додати умову',
    'addContract' : 'Додати договір',
    'addCulture' : 'Додати ще культуру',
    'addMore' : 'Додати ще',
    'address' : 'Адреса',
    'addressDelivery' : 'Адреса доставки',
    'addressFact' : 'Факт. Адреса',
    'addressLaw' : 'Юр. Адреса',
    'addFeedback' : 'Додати відгук',
    'addSellerFeedback' : 'Додати відгук про продавця',
    'addToBasket' : 'Додати в кошик',
    'addToBasketSuccess' : 'успішно додано до кошика',
    'addToOften' : 'Додати в часті',
    'addingProduct' : 'Додати товар',
    'addFile' : 'Прикріпити файл',
    'addProductError' : 'Помилка при додаванні товару',
    'addProductSuccess' : 'Товар успішно додано',
    'agrarianReceipt' : 'Аграрна розписка',
    'agrolinkManager' : 'Менеджер Агролінк',
    'alreadyInBasket' : 'Вже в кошику',
    'and' : 'та',
    'alreadyHaveAccount' : 'Вже є аккаунт ?',
    'alreadyRegistered' : 'Вже зареєстровані?',
    'all' : 'Всі',
    'allAvailableProductsOnTheMarket' : 'Всі доступні товари на ринку',
    'allProductsNotCompleted' : 'Всі товари не оформилися',
    'apply' : 'Застосувати',
    'archive' : 'Архів',
    'articleNumber' : 'Артикул',
    'arriveDate' : 'Дата доставки',
    'avatarDeleted' : 'Аватар видалено',
    'authChecking' : 'Перевірка авторизації',
    'avatarSettings' : 'Налаштування аватару',
    'asSoonPossible' : 'Якомога швидше',
    'attach' : 'Прикріпити',
    'back' : 'Назад',
    'backToOrders' : 'Повернутися до замовлень',
    'bankName' : 'Назва банку',
    'bankMfo' : 'МФО',
    'bankAccount' : 'Розрахунковий рахунок',
    'balance' : 'Залишок',
    'balancePart' : 'Передплатна частина',
    'basket' : 'Кошик',
    'basketEmpty' : 'Ваш кошик пуст',
    'before' : 'До',
    'begin' : 'Почати',
    'billOfExchange' : 'Авальований вексель',
    'budget' : 'Бюджет',
    'buyer' : 'Покупець',
    'buyerRegistration' : 'Реєстрація для покупок',
    'buyerRegWelcomeMessage' : 'Зареєструйтесь, щоб почати купляти напряму в постачальників',
    'changeStatus' : 'Змінити статус',
    'buy' : 'Купити',
    'buyAllSellers' : 'Оформити всіх продавців',
    'buyAgrolink' : 'Оформити через Agrolink',
    'buyAll' : 'Оформити все',
    'buyWithProduct' : 'З цим товаром купують',
    'byDate' : 'За датою',
    'byPriceMin' : 'За ціною (спочатку дешеві)',
    'byPriceMax' : 'За ціною (спочатку дорогі)',
    'byRating' : 'За рейтингом',
    'byRecommendation' : 'За рекомендацією',
    'byRequest' : 'На запит',
    'byViews' : 'За переглядами',
    'cancel' : 'Скасувати',
    'cancelFilters' : 'Скинути',
    'calculator' : 'Калькулятор',
    'calculating' : 'Розрахунок',
    'calculateTheCost' : 'Розрахувати вартість',
    'calculationResult' : 'Результат калькуляцї',
    'calculatorStep1stHeader' : 'Введіть будь ласка інформацію нижче і ми запропонуємо оптимальні варіанти захисту для поля. Всього три кроки і індивідуальна тех-карта готова!',
    'calculatorStep2ndHeader' : 'Будь ласка, виберіть кількість фаз обробки вашого поля і типи препаратів, які збираєтеся використовувати.',
    'calculatorStep3rdHeader' : 'Тепер для ваших фаз обробки і типів препаратів вкажіть проблематику і бюджет на 1 гектар. Так Агролінк зможе підібрати найбільш точні варіанти продуктів.',
    'calculatorStep4thHeader' : 'Ура! На Агролінк є результати за вашим параметрам. Виберіть один зі списку щоб препарат врахувався у бюджеті.',
    'category' : 'Категорія',
    'catalog' : 'Каталог',
    'categories' : 'Категорії',
    'characteristics' : 'Характеристики',
    'change' : 'Змінити',
    'changesSaved' : 'Зміни збережені',
    'changesSavedError' : 'Помилка при збереженні даних',
    'cheap' : 'Дешеві',
    'checkout' : 'Оформити',
    'checkoutInBasket' : 'Оформити в кошику',
    'checkoutProduct' : 'Оформити товар',
    'checkoutProducts' : 'Оформити товари',
    'chemicalClass' : 'Хімічний класс',
    'choose' : 'Вибрати',
    'chooseOneOption' : 'Оберіть один з варіантів',
    'chooseContract' : 'Вибрати договір',
    'chooseProblemsDrugTypes' : 'Оберіть проблематику для типів препарату',
    'chooseTypesOfDrug' : 'Оберіть один або кілька типів препарата',
    'chooseVariants' : 'Оберіть варіанти',
    'contactUs' : 'Зв\'язатися з нами',
    'city' : 'Місто',
    'close' : 'Закрити',
    'codeEgrpou' : 'Код ЕДРПОУ',
    'collapse' : 'Згорнути',
    'comments' : 'Коментарі',
    'commission': "Комісія Liqpay",
    'commonCost' : 'Загальна вартість',
    'commonBudgetOnHectare' : 'Загальний бюджет обробки гектара',
    'companies' : 'Компанії',
    'company' : 'Компанія',
    'companyLogo' : 'Лого компанії',
    'companyDescriptionRu' : 'Опис компанії російською',
    'companyDescriptionUa' : 'Опис компанії на українському',
    'companyName' : 'Назва компанії',
    'companyNameRu' : 'Назва компанії російською',
    'companyNameUa' : 'Назва компанії на українському',
    'companyRepresentatives' : 'Представники компанії',
    'companyInfo' : 'Інформація про компанію',
    'compare' : 'Порівняти',
    'compareProducts' : 'Порівняти продукти',
    'commercialPolicy' : 'Комерційна політика',
    'commercialPolicies' : 'Політика знижок',
    'commentAboutCompany' : 'Залиште коментар про продукт',
    'condition' : 'Умова',
    'contact' : 'Контакт',
    'contactName' : 'Назва контакту',
    'continueShopping' : 'Продовжити покупки',
    'contract' : 'Договір',
    'contractAdded' : 'Договір доданий',
    'contacts' : 'Контакти',
    'contactsManager' : 'Контактні особи',
    'contactPerson' : 'Контактна особа',
    'contactsInfo' : 'Контактна інформація',
    'contractual' : 'Договірна',
    'confirm' : 'Підтвердити',
    'confirmOrder' : 'Підтвердити оформлення',
    'costPerHectare' : 'Витраты на 1 гектар',
    'credit' : 'Кредит',
    'creditPart' : 'Кредитна частина',
    'credentialsPassword' : 'Встановити пароль',
    'credentialsWithEmail' : 'Встановити пароль та email',
    'currency' : 'Валюта',
    'culture' : 'Культура',
    'customAttributesNames' : {
        'kultura' : 'Культура і норма використання',
    },
    'dataErrorUpdated' : 'Помилка при оновленні даних',
    'dataSuccessUpdated' : 'Дані успішно оновлені',
    'date' : 'Дата',
    'dateFrom' : 'дата от',
    'dateTo' : 'дата до',
    'delivery' : 'Доставка',
    'deliveryDate' : 'Дата доставки',
    'delete' : 'Видалити',
    'deleteAvatar' : 'Видалити аватар',
    'deliveryToAnywhere' : 'Доставка в будь-яку точку',
    'department' : 'Відділ',
    'deselectAll' : 'Скасувати виділення',
    'description' : 'Опис',
    'descriptionRu' : 'Опис товару на Російському',
    'descriptionUa' : 'Опис товару на Українському',
    'details' : 'Детали',
    'dimensions' : 'Габарити',
    'discount' : 'Знижка',
    'discountByCommercialPolicy' : 'Знижка за комм. політикою',
    'discountInPercent' : 'Знижка в %',
    'diseases' : 'Захворювання',
    'distributorRegions' : 'Регіони продавця',
    'downloadPresentation' : 'Завантажити презентацію',
    'doYouWantToDeleteSale' : 'Ви дійсно хочите відмовитись від продажу?',
    'doYouWantToDeleteBought' : 'Ви дійсно хочите відмовитись від закупівлі?',
    'drugEffectOnProblem' : 'Дія препарата на проблему',
    'edit' : 'Редагувати',
    'edprou' : 'ЕГРПОУ',
    'emptyBasket' : 'У Вашому кошику поки немає товарів',
    'enter': 'Увійти',
    'enterBudget' : 'Введіть бюджет',
    'enterRate' : 'Введіть бажану норму',
    'enters' : 'Увійдіть',
    'emailInvalid' : 'Введіть коректний email',
    'emailRequired' : 'Вкажіть email',
    'enterWithHelp' : 'увійти за допомогою',
    'existence' : 'Наявність',
    'exit' : 'Вихід',
    'exit?' : 'Вийти ?',
    'expensive' : 'Дорогі',
    'factoryDirectPriceWithoutSpeculation' : 'Пряма ціна від виробника без спекуляцій',
    'favorites' : 'Вибране',
    'farmziBenefits' : 'Переваги Агролінк',
    'faqDialogTitle' : 'Заповніть будь ласка коротку форму і ми зв\'яжемося з Вами найближчим часом',
    'feedback' : 'Зворотній зв\'язок',
    'feedbackOne' : 'Відгук',
    'feedbackMore' : 'Відгуки',
    'feedbacks' : 'Відгуків',
    'feedbackAboutCompany' : 'Відгуки про компанію',
    'feedbackSend' : 'Відгук відправлений',
    'fertilizers' : 'Добрива',
    'firstName' : 'Ім\'я',
    'firstTimeAtFarmzi' : 'Вперше на AGROLINK?',
    'filter' : 'Фільтр',
    'filters' : 'Фільтри',
    'filterBy' : 'Фільтрувати по',
    'filterTo' : 'Фільтрувати',
    'financeAndConfirmation' : 'Фінанси і підтвердження',
    'for' : 'за',
    'forAgriculturalProducer' : 'Для аграрія',
    'forFarmer' : 'Для фермера',
    'forCompany' : 'Для компанії',
    'forPhase' : 'для фази',
    'forSeller' : 'Для продавця',
    'forgetPassword' : 'Забули пароль',
    'forManufacturer' : 'Для виробника',
    'from' : 'з',
    'fromOt' : 'Від',
    'fromCompany' : 'від компанії',
    'fromSeller' : 'від продавця',
    'freeRegistration' : 'Безкоштовна реєстрація',
    'freeShipping' : 'Безкоштовна доставка',
    'fundsWillBeRefunded' : 'Після скасування кошти будуть повернуті',
    'generalInfo' : 'Загальна інформація',
    'getStartedAtFarmzi' : 'Почніть працювати на AGROLINK',
    'goTo' : 'Перейти',
    'goToCalculator' : 'Перейти в Калькулятор',
    'height' : 'Висота',
    'hello' : 'Вітаю',
    'help' : 'Допомога',
    'helpfulInfo' : 'Корисна інформація',
    'helpCenter' : 'Довідковий центр',
    'howToBuy' : 'Як робити закупки на AGROLINK',
    'howToSell' : 'Як продавати на AGROLINK',
    'homeBudgetCalculator' : 'Калькулятор бюджету на обробку пестицидами',
    'homeCalculatorSubtitle' : 'Робіть детальний розрахунок бюджету на пестицидну обробку ваших полів і знаходьте оптимальні альтернативи.',
    'homeCalculatorSubtitle1': 'Робіть детальний розрахунок бюджету на пестицидну обробку ваших полів за 5 хвилин. Спочатку введіть культуру, кількість гектар та обробок.',
    'homeCalculatorSubtitle2': 'Вкажіть бюджет та проблематику з котрою потрібно боротись. В результаті ви отримаєте оптимальні препарати під ваш бюджет, котрі максимально підійдуть під Ваши потреби',
    'homeFarmersText' : [
        {id: 1, text:'1. Економія бюджету;'},
        {id: 2, text:'2. Швидкий пошук товарів за важливими характеристиками;'},
        {id: 3, text:'3. Порівняння товарів та усвідомлений вибір;'},
        {id: 4, text:'4. Актуальні ціни та наявність;'},
        {id: 5, text:'5. Зручна доставка по всій Україні.'},
    ],
    'homeManufacturersText' : [
        {id: 1, text:'1. Збільшення продажів без виділення додаткового ресурсу компанії;'},
        {id: 2, text:'2. Допомога у логістиці та операційному документообігу;'},
        {id: 3, text:'3. Підтримка 24/7;'},
        {id: 4, text:'4. Безкоштовне розміщення на пробний період.'},
    ],
    'howFindUs' : 'Як ви про нас дізналися',
    'howPlatformWorks' : 'Як працює онлайн платформа',
    'iAgreeWith' : 'Згоден з',
    'inBuy' : 'В закупівлю',
    'homeHeadTitle' : 'Купуйте товари для поля онлайн з вигодою 5-15% безпосередньо від постачальників',
    'homeWhatIs' : 'AGROLINK пропонує фермерам і виробникам інструментарій технологій для моніторингу цін, формування закупівлі, переговорів, підписання договору купівлі і автоматизації повторних закупівель',
    'history': 'Історія',
    'inProcess' : 'В процесі',
    'inStock' : 'В наявності',
    'invalidValue' : 'Недійсне значення',
    'inDevelopment' : 'Знаходиться в розробці',
    'influenceType' : 'Тип впливу',
    'issue' : 'Оформити',
    'kg' : 'кг',
    'lastEdit' : 'Остання зміна',
    'lastName' : 'Прізвище',
    'law' : 'Юридична особа',
    'lawInfo' : 'Юридична інформація',
    'length' : 'Довжина',
    'legalEntityName' : 'Повна назва юридичної особи',
    'linkCopied' : 'Лінк скопійовано',
    'linkNotCopied' : 'Лінк не скопійовано',
    'loadingPleaseWait' : 'Завантаження... будь ласка, зачекайте',
    'login' : 'Вхід',
    'loginWelcomeMessage': 'Вас очікують сотні товарів',
    'loginError' : 'Увійти не вдалося. Зв\'яжіться з адміністрацією.',
    'logoAlt' : 'Платформа для пошуку агропромислової продукції',
    'logoTitle' : 'Незалежна платформа агропромислової продукції - Agrolink.com.ua',
    'logout' : 'Вийти',
    'look' : 'Подивитися',
    'lowLevel': 'Закінчується',
    'joinToAgrolink' : 'Приєднатися до Агролінк',
    'knowCost' : 'Дізнатися вартість',
    'knowPrice' : 'Дізнатись ціну',
    'knowExistence' : 'Дізнатись наявність',
    'm' : 'м',
    'mainData' : 'Основні дані',
    'mainInfo' : 'Основна інформація',
    'mainPage' : 'На головну',
    'makeSellerOrder' : 'Оформити товари цього продавця',
    'manualEntry' : 'Ввести норму вручну',
    'manufacturersSelection' : 'Відбір виробників',
    'manufacturers' : 'Обирайте товари і купуйте напряму у виробника',
    'maxSum' : 'Макс. сума',
    'mayBeSearch' : 'Можливо ви шукали',
    'message' : 'Повідомлення',
    'messages' : 'Повідомлення',
    'messagesToSeller' : 'Повідомлення продавцю',
    'messageSent' : 'Повідомлення відправлено',
    'messageText' : 'Текст повідомлення',
    'minOrder' : 'Мін. замов.',
    'minimumOrder' : 'Мінімальний лот продажу',
    'minimumOrderUnit' : 'Мінімальний обсяг поставки',
    'minimumOrderHelp' : 'Мін. замовлення буде також відображати кратність. Наприклад, ви продаєте 5 л каністри і вказали мін замовлення 4 каністри. Клієнт зможе купити 4, 8, 12, 16 і тд. каністр з кроком +4.',
    'minSum' : 'Мін. сума',
    'more' : 'Ще',
    'moreDetails' : 'Детальніше',
    'month' : 'Місяць',
    'mostPopularProducts' : 'Найпопулярніші товари на Агролінк',
    'myBasket' : 'Мої закупівлі',
    'myContracts' : 'Мої договори',
    'myInfo' : 'Моя інформація',
    'myProducts' : 'Мої товари',
    'mySales' : 'Мої продажі',
    'myPurchases' : 'Мої закупівлі',
    'name' : 'Найменування',
    'nameSurname' : 'ПІБ',
    'nameRu' : 'Найменування на Російському',
    'nameUa' : 'Найменування на Українському',
    'needHelp' : 'Потрібна допомога?',
    'newPurchase' : 'Нова закупівля',
    'newsAndBlog' : 'Новини і блог',
    'next' : 'Далі',
    'noEnoughCompareProducts' : 'Поки ви додали один товар, додайте ще для порівняння',
    'noData' : 'Нажаль, за обраними характеристиками товарів немає.',
    'noAccount' : 'Немає акаунту',
    'noFeedbacks' : 'Відгуків про компанію немає, але ви можете стати першим!',
    'noFeedbacksProduct' : 'Відгуків про товар немає, але ви можете стати першим!',
    'noProblematic' : 'Проблематика не передбачена',
    'noProducts' : 'У вас немає товарів у обраному...',
    'norm' : 'Норма',
    'notActivated' : 'Аккаунт не активоване. Перевірте вказаний email для активації облікового запису.',
    'notAvailable': 'Немає в наявності',
    'notExistingPage' : 'Неправильно набрано адресу, або такої сторінки вже не існує.',
    'notFound' : 'Нічого не знайдено',
    'notes': 'Примітки',
    'numberOfDays' : 'Кіл-сть днів',
    'numberOfMonths' : 'Кіл-сть місяців',
    'numberOfHectares' : 'Кіл-сть гектар',
    'numberOfTreatments' : 'Кіл-сть обробок',
    'oftenSearched': 'Найчастіше шукають',
    'often': 'Часті',
    'or': 'або',
    'order' : 'Замовлення',
    'orderConfirmMessage1' : 'Отримання замовлення від 5 000 UAH тільки із паспортом (Закон від 06.12.2019 № 361-IX)',
    'orderConfirmMessage2' : 'Підтверджуючи замовлення, я приймаю умови',
    'orderConfirmMessage3' : 'В замовлення включена комісія платіжної системи Liqpay (2.75%) на товари Агролінк.',
    'orderCreating': 'Оформлення замовлення',
    'orderDate': 'Дата замовлення',
    'orderError': 'Помилка при оформленні товару',
    'orderHasBeenPaid' : 'Це замовлення оплачене',
    'orderLot': 'Одиниця замовлення',
    'orderNumber': 'Номер замовлення',
    'orderPrice': 'Сума замовлення',
    'orderProducts': 'Товари',
    'orderRemoveError': 'Помилка при видаленні замовлення',
    'orderRemoveSuccess': 'Замовлення успішно видалене',
    'orderSuccess': 'Замовлення успішно оформленне',
    'orderUpdated': 'Замовлення змінене',
    'orderUpdatedError': 'Помилка при зміні замовлення',
    'orderValue': 'Обсяг закупівлі',
    'otherSellers': 'Інші продавці',
    'overprice' : 'Перевищення бюджету',
    'packedBy': 'Розфасоване по',
    'packing': 'Фасування',
    'packType': 'Тип упаковки',
    'partners': 'Наші партнери',
    'passwordRequired': 'Вкажіть пароль',
    'payInfo': 'Платіжна інформація',
    'payment': 'Оплата',
    'paymentAndDelivery': 'Оплата і доставка',
    'paymentMethod': 'Метод оплати',
    'paymentWay': 'Спосіб оплати',
    'paymentWaySet': 'Вкажіть спосіб оплати',
    'paymentWayEnterNameAndCode' : 'Введіть будь ласка назву і код ЄДРПОУ юридичної особи',
    'personalCabinet' : 'Особистий кабінет',
    'personalInfo' : 'Особиста інформація',
    'personalProfile' : 'Особистий профіль',
    'personalInfoSettings' : 'Налаштування особистої інформації',
    'phoneInvalid': 'Введіть коректний номер телефону',
    'phoneNumber' : 'Номер телефону',
    'pesticides' : 'Пестициди',
    'physical' : 'Фізична особа',
    'pickPassword' : 'Придумайте пароль',
    'positiveFeedback' : 'Позитивних відгуків з',
    'Prepayment' : 'Передоплата',
    'price' : 'Ціна',
    'price&quantity': 'Ціна і кількість',
    'priceFrom' : 'Ціна от',
    'priceTo' : 'Ціна до',
    'priceAndAvailabilityInformationInTwoClicks' : 'Інформація про ціну і наявність в 2 кліка',
    'priceWithNds' : 'Ціна вказана з урахуванням ПДВ',
    'priceWithoutNds' : 'Ціна вказана без урахування ПДВ',
    'priceWithDiscount' : 'Ціна зі знижкою',
    'priceNotSpecified' : 'Ціна не вказана',
    'privacyAccept' : 'Ви повинні прийняти політику конфіденційності',
    'privacyPolicy' : 'Політика конфіденційності',
    'prepare' : 'Оформити цього продавця',
    'problems' : 'Проблематика',
    'problemsAndBudget' : 'Проблематика та бюджет',
    'processingHectares' : 'обробки гектара',
    'processingPhases' : 'Фази обробки',
    'producer' : 'Виробник',
    'productData' : 'Дані товару',
    'productDescription' : 'Опис товару',
    'productEnumDialogMessage' : 'Зеленим кольором виділені проблеми які лікує',
    'productFavoritesDelete' : 'Товар вилучений з обраного',
    'productPage' : 'Сторінка товару',
    'products' : 'Товарів',
    'productsCategories' : 'Категорії товарів на агролінк',
    'productsCount' : 'Всього товарів',
    'productParams' : 'Характеристики товару',
    'productsFound' : 'Товарів знайдено',
    'productsManage' : 'Управління товарами',
    'productOrder' : 'Оформлення товару',
    'productsToOrder' : 'Товари до оформлення',
    'productsAreNotProm' : 'Товари яких немає на Prom',
    'productUpdating' : 'Редагуваня товара',
    'productsWithDiscount' : 'Товари зі знижками',
    'productsAreBoughtOnline' : 'Товари, які купуються онлайн',
    'productsPurchasedApp' : 'Товари, які купуються через заявку',
    'profileHeader' : 'Профіль користувача',
    'profileSettings' : 'Налаштування профілю',
    'promoSale' : 'Акція',
    'provision' : 'Забезпечення',
    'purchasesAtAgrolink' : 'Закупівлі на Агролінк',
    'purchaseAmount' : 'Сума закупівлі',
    'purchasingAtFarmzi' : 'Закупівля на AGROLINK це',
    'quantity': 'Кількість',
    'quantityCut': 'Кіл-ть',
    'questionsAndAnswers' : 'Питання та відповіді',
    'readMore' : 'Читати далі',
    'realizationForm': 'Форма реалізації',
    'recommendedAccordingPacking' : 'Реком. замовлення відповідно до упаковки',
    'recommendedRateByManufacturer' : 'Рекомендована норма використання від виробника',
    'region': 'Регіон',
    'regions': 'Регіони',
    'regionSearch': 'Пошук в регіоні',
    'register': 'Зареєструватися',
    'registration': 'Реєстрація',
    'remove': 'Вилучити',
    'results' : 'Результати',
    'return': 'Повернути',
    'retailPrice': 'Роздрібна ціна ',
    'resetPassword': 'Скинути пароль',
    'requiredField': 'Обов\'язкове поле',
    'requiredQuantity': 'Необхідна к-сть',
    'requestPasswordError': 'Помилка при запиті скидання пароля. Зв\'яжіться з адміністрацією.',
    'requestPassword': 'Запросити скидання пароля',
    'rowsPerPage': 'Ряди на сторінці',
    'saleUnit': 'Одиниця продажу',
    'save': 'Зберегти',
    'savePassword': 'Зберегти пароль',
    'saving' : 'Економія',
    'section' : 'Розділ',
    'selectAll' : 'Вибрати все',
    'selectAllRegions' : 'Вибрати всі регіони',
    'selectDate' : 'Вибрати дату',
    'selectDateDelivery' : 'Виберіть дату поставки',
    'selectDrugs' : 'Виберіть препарати',
    'selectPaymentMethod' : 'Виберіть метод сплати',
    'selectProductQuantity': 'Оберіть кількість товару',
    'selectFile' : 'Виберіть файл',
    'selectedDrugs' : 'Вибрані препарати',
    'selfShipmentText1' : 'Агролінк супроводжує угоду',
    'selfShipmentText2' : 'Доставка оплачується одержувачем',
    'seller' : 'Продавець',
    'sellers' : 'Продавці',
    'sellersProducts' : 'Товари продавця',
    'sellerInformation' : 'Інформація про продавця',
    'sellerRegistration' : 'Продавати на Агролінк',
    'sellerRegWelcomeMessage' : 'Агролінк - це онлайн-платформа для прямої взаємодіі постачальника та аграрія. Ми працюємо тільки з виробниками і допомагаємо збільшити об\'єм без виділення додаткового ресурсу.',
    'seeds' : 'Насіння',
    'seeMore' : 'подивитися ще',
    'send' : 'Відправити',
    'settlement' : 'Населений пункт',
    'set' : 'Встановити',
    'setRecommendOrderDate' : 'Вкажіть рекомендовану дату поставки',
    'siteSearch' : 'Пошук',
    'siteSearchBanner' : 'Пошук за ДР, проблематикою, продуктом та виробником',
    'size' : 'Розмір',
    'show' : 'Показати',
    'showMore' : 'Показати більше',
    'sortBy' : 'Сортувати',
    'somethingWentWrongTryAgainLater' : 'Щось пішло не так. Спробуйте пізніше',
    'specification' : 'Специфікація',
    'specifyRateManually' : 'Вкажіть норму використання вручну',
    'startSelling' : 'Почати продавати на Агролінк',
    'stillQuestions' : 'Залишились запитання?',
    'subCategories' : 'Підкатегорії',
    'successfulAddedOften' : 'Успішно додано в часті',
    'successfulDeletedOften' : 'Успішно видалено з частих',
    'successfulDeleted' : 'Успішно видалено',
    'sum' : 'Сума',
    'sumMax' : 'Макс. сума',
    'sumMin' : 'Мін. сума',
    'summaryCost': 'Підсумкова вартість',
    'supplier' : 'постачальник',
    'szr' : 'ЗЗР',
    'targetBudget' : 'Заданий бюджет',
    'telephone' : 'Телефон',
    'thankYouForYourPurchase' : 'Дякую за оформлення закупівлі',
    'thankYouForAddProduct' : 'Дякую за додавання товару',
    'thankYouForFeedback' : 'Дякую за ваш зворотний зв\'язок',
    'thankYouForFaqMessage' : 'Дякую за звеconfirmOrderрнення, зв\'яжемося з Вами найближчим часом',
    'thankYouForSellerRegistration' : 'Дякуємо за заявку на приєднання до спілки Agrolink! В Agrolink ми співпрацюємо з українськими та міжнародними брендами, щоб допомогти їм збільшувати продажі і розвивати свій бізнес. У зв\'язку з цим ми приділяємо час перевірки кожного учасника. Ми зв\'яжемося з вами найближчим часом!',
    'theme' : 'Тема',
    'toBasket' : 'В Кошик',
    'toCatalog' : 'В каталог',
    'total' : 'Разом',
    'toPay' : 'До оплати',
    'toPurchase' : 'В закупівлю',
    'typesDrugsByPhase' : 'Типи препаратів за фазами',
    'treaty' : 'Договірна',
    'uah' : 'ГРН',
    'updateOrder' : 'Змінити замовлення?',
    'uploadImage' : 'Завантажити аватар',
    'undefined' : 'Не вказано',
    'unitOfMeasure' : 'Од. виміру',
    'unitWeight' : 'Вага одиниці товару',
    'userAgreement' : 'Угода користувача',
    'usersAgreement' : 'Угоди користувача',
    'view' : 'Вид',
    'viewResults' : 'Показати результати',
    'wantAddOften' : 'Додати в часті?',
    'wantAddOftenSelected' : 'Додати вибрані в часті?',
    'wantDeleteOften' : 'Видалити з частіх',
    'wantDeleteOrder' : 'Видалити заявку?',
    'wantRemoveAll' : 'Видалити все?',
    'wantRemoveSelected' : 'Видалити відмічені?',
    'whatIsFarmzi' : 'Що таке AGROLINK?',
    'website' : 'Сайт',
    'weight' : 'Вага упаковки',
    'welcome' : 'Ласкаво просимо',
    'wholesaleAgroPurchasingInSmartPhone' : 'Оптові Агро-Закупівлі В Смартфоні',
    'wholesalePrice' : 'Оптова ціна',
    'wholesaleFrom' : 'Опт від',
    'width' : 'Ширина',
    'withNds' : 'З ПДВ',
    'withoutNds' : 'Без ПДВ',
    'withPrivacyPolicy' : 'Політикою конфіденційності',
    'withPrivacyPolicies' : 'Політики конфіденційності',
    'withUserAgreement' : 'Угодою користовача',
    'write' : 'Написати',
    'writeToSeller' : 'Написати продавцеві',
    'writeSellerFeedback' : 'Напишіть ваш відгук',
    'withoutDelivery' : 'без доставки',
    'withoutProblems' : 'Без проблематики',
    'wrongCredentials' : 'Введено неправильні email або пароль',
    'yes' : 'Так',
    'youMayLike' : 'Вам може сподобатися',
    'youViewedEarlier' : 'Ви переглядали раніше',
    'yourName' : 'Ваше ім\'я',
    'yourProductSaved' : 'Ваш товар успішно збережений!',
}
